import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";

export default function SuccessDialog({ open, onClose, duration, flips }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          minWidth: { xs: "auto", sm: 420 },
          borderRadius: 5,
          border: "1px solid rgba(255,255,255,0.12)",
          background:
            "linear-gradient(180deg, rgba(13, 30, 56, 0.98), rgba(7, 16, 29, 0.98))",
          boxShadow: "0 26px 80px rgba(0, 0, 0, 0.35)",
        },
      }}
    >
      <DialogTitle sx={{ textAlign: "center", pb: 1 }}>
        Congratulations!
      </DialogTitle>
      <DialogContent>
        <Stack spacing={1.5} alignItems="center" textAlign="center">
          <Typography variant="body1">
            You matched all the cards and cleared the board.
          </Typography>
          {duration !== null && (
            <Typography sx={{ color: "rgba(255,255,255,0.82)" }}>
              Time taken: <strong>{duration}</strong> seconds
            </Typography>
          )}
          <Typography sx={{ color: "rgba(255,255,255,0.82)" }}>
            Total Flips: <strong>{flips}</strong>
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 3, pt: 0 }}>
        <Button
          onClick={onClose}
          color="primary"
          variant="contained"
          sx={{ px: 4, py: 1.2, borderRadius: 999, color: "#082032" }}
        >
          Replay
        </Button>
      </DialogActions>
    </Dialog>
  );
}
